import { render, staticRenderFns } from "./user_info_add.vue?vue&type=template&id=1c184cc5&scoped=true&lang=pug&"
import script from "./user_info_add.vue?vue&type=script&lang=js&"
export * from "./user_info_add.vue?vue&type=script&lang=js&"
import style0 from "./user_info_add.vue?vue&type=style&index=0&id=1c184cc5&lang=scss&scoped=true&"
import style1 from "./user_info_add.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c184cc5",
  null
  
)

export default component.exports